@if (shopHeader() && headerSlimFacadeService.navSlimDetails()) {
  <idp-nav-slim-links
    [shopContent]="headerSlimFacadeService.navSlimDetails()"
    (modifyButtonClicked)="onClick($event)"
  ></idp-nav-slim-links>
}

@if (
  vacationFlowInput().enableHeader &&
  vacationHeaderFacadeService.vacationSearchContent()
) {
  <idp-nav-slim-links
    [vacationContent]="vacationHeaderFacadeService.vacationSearchContent()"
    [vacationFlowInput]="vacationFlowInput()"
    (vacationFlowOutput)="vacationFlowOutputEvent($event)"
  ></idp-nav-slim-links>
}
